import {
    default as accordionSupport,
    setInitialStateForTabSet,
    bindAccordionChangeEvent,
    mergeTabSetState
} from '../../../core/js/uiSupport/accordion';

import {
    requestFacetedItems,
    clearCustomPriceRange,
    setSelectedFacet
} from '../actions/facetActions';

import template from 'facets/category-facets.j2';
import { mDom, mDomFacetHomogenousLinkTypes } from '../../../core/js/utils/renderUtils';
import { generate, templateLocationExists } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { bindOnPopStateEvent } from '../../../core/js/utils/browserUtils';
import { isDownPressed, isUpPressed } from '../../../core/js/utils/keyUtils';
import {
    getCurrentCategory,
    onCategoryPopstate,
    updateScrollPositionForFacets,
    getLastFacetItemByFilterType,
} from '../utils/utils';

import { init as initCustomPriceRangeComponent } from './customPriceRangeComponent';

const FACET_LOAD_CONFIG = { location: '.js-category-grid' };

/**
 * Attach component events to DOM
 * @param {object} store - The store
 * @returns {undefined}
 */
export function attachEvents(store) {
    this.store = store;
    bindOnPopStateEvent(this, onCategoryPopstate);

    // 'keydown' allows users to navgiate through facet option using up and down arrows
    // the 'keydown' event fires twice so we need to unbind one of the events by calling document.off
    $(document).off(this.scopedEvent('keydown'), this.scopedSelector("[name='facet-option']"));
    $(document).on(this.scopedEvent('keydown'), this.scopedSelector("[name='facet-option']"), (e) => {
        if (isUpPressed(e)) {
            e.preventDefault();
            $(e.target).closest("[name='facet-option']")
                                   .prev("[name='facet-option']")
                                   .find('.js-facet__a')
                                   .focus();
        }

        if (isDownPressed(e)) {
            e.preventDefault();
            $(e.target).closest("[name='facet-option']")
                                   .next("[name='facet-option']")
                                   .find('.js-facet__a')
                                   .focus();
        }
    });

    $(document).on('click', '.js-facet__a', (e) => {
        e.preventDefault();
        this.attachLoader(store, FACET_LOAD_CONFIG);
        const el = $(e.currentTarget);
        const categoryId = getCurrentCategory();
        const facetName = el.closest('[data-facet-name]').attr('data-facet-name');
        const facetValue = el.closest('[data-facet-value]').attr('data-facet-value');
        const isSelected = el.is(':checked');
        const qs = el.attr('data-query-string');

        store.dispatch(setSelectedFacet(facetName));
        store.dispatch(requestFacetedItems(categoryId, facetName, facetValue, isSelected, qs, true, e, this));
    });

    $(document).on(`touchend.${this.templateLocation} click.${this.templateLocation}`,
    '.js-clear-custom-price-facet', (e) => {
        store.dispatch(clearCustomPriceRange());
    });

    $(document).on(`touchend.${this.templateLocation} click.${this.templateLocation}`, '.js-facets-reset', (e) => {
        e.preventDefault();
        if (!store.getState().category.queryString) {
            return false;
        }
        const el = $(e.currentTarget);
        const qs = el.attr('data-facets-reset');
        const categoryId = getCurrentCategory();

        store.dispatch(clearCustomPriceRange());
        store.dispatch(requestFacetedItems(categoryId, '', '', false, qs));
        return true;
    });

    bindAccordionChangeEvent.bind(this)();

    $(document).on(this.scopedEvent('click'), '.js-facets-see-all', (e) => {
        e.preventDefault();

        this.attachLoader(store, FACET_LOAD_CONFIG);
        this.lastFacetItemByFilterType = getLastFacetItemByFilterType(this);
        const facetName = $(e.target).attr('data-facet-name');
        const categoryId = getCurrentCategory();
        const qs = $(e.target).attr('data-query-string');

        store.dispatch(setSelectedFacet(facetName, null, true));
        store.dispatch(requestFacetedItems(categoryId, facetName, '', false, qs, true, e, this));
    });

    $(document).on('RECEIVED_CATEGORY_ITEMS', (e) => {
        this.removeLoader(store);
    });
}

export function onStateChange(store, watchValue, oldVal, newVal) {
    if (newVal.renderedFacets !== oldVal.renderedFacets) {
        this.render(store, this, {});
    } else {
        this.afterRender(store);
    }
}

export function afterRender(store) {
    accordionSupport(this, this.templateLocation);
    updateScrollPositionForFacets(this);
}

function afterConstruction(store) {
    accordionSupport(this, this.templateLocation);
    setInitialStateForTabSet.call(this);
}

/**
 * Bootstrap the component onto the page
 * @param {object} store - The store
 * @param {object} overrides - The overrides object
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        children: [
            initCustomPriceRangeComponent
        ],
        templateLocation: '.dom-facets',
        isComponentValid: templateLocationExists,
        watch: 'category',
        name: 'facetComponent',
        attachEvents: attachEvents,
        onStateChange: onStateChange,
        afterConstruction: afterConstruction,
        template: template,
        afterRender: afterRender,
        renderType: mDom,
        renderOptions: mDomFacetHomogenousLinkTypes,
        beforeInsertion: mergeTabSetState,
        accordionState: {},
        accordionNameDataAttr: 'data-accordion-tab-name',
        jsAccordionClass: '.js-accordion-tabset',
        rebind: true,
        lastFacetItemByFilterType: {}
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
